import React from 'react';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import TextInput from '@/components/common/TextInput';
import { getStringOrEmpty } from '@/utils/helper';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  errorBanner: boolean;
  labelTitle: string;
  maxLength?: number;
  handleAlbumField: (field: string, value: string) => void;
};

export default function CatalogNumberFormGroup({
  album,
  errorBanner,
  readonly,
  disabled,
  labelTitle,
  maxLength,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumField,
}: Props) {
  const hasCatalogNumberError = fieldHasErrors('CatalogNumber');

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.product.catalogNumber"
      hasErrors={
        hasCatalogNumberError ||
        (showValidationErrors && errorBanner && !album.catalogNumber)
      }
    >
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={labelTitle}
        handleInput={(e) => {
          handleAlbumField('catalogNumber', e.target.value);
        }}
        id="catalogNumber"
        type="text"
        value={getStringOrEmpty(album.catalogNumber)}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={hasCatalogNumberError}
        errorMessage={findErrorMessage('CatalogNumber')}
        isRequired={true}
        showValidationErrors={showValidationErrors}
        fieldValidationKey={'productEditMode.CatalogNumber'}
        maxLength={maxLength}
      />
    </FormGroupWithTooltip>
  );
}
